/**
 * Tagged template for building markup.
 *
 * Interpolated values are HTML-escaped by default. Arrays are joined, null and
 * false are dropped so `${cond && html`…`}` works, and values wrapped in `raw()`
 * pass through untouched.
 */
const RAW = Symbol('raw');

const ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export const escape = (value) => String(value).replace(/[&<>"']/g, (c) => ESCAPES[c]);

export const raw = (value) => ({ [RAW]: String(value) });

const resolve = (value) => {
  if (value == null || value === false || value === true) return '';
  if (Array.isArray(value)) return value.map(resolve).join('');
  if (typeof value === 'object' && RAW in value) return value[RAW];
  return escape(value);
};

export const html = (strings, ...values) =>
  raw(strings.reduce((out, str, i) => out + str + (i < values.length ? resolve(values[i]) : ''), ''));

/** Render a template to a plain string, for assigning to innerHTML. */
export const render = (value) => resolve(value);

/** Build a class attribute value from conditional parts. */
export const classes = (...parts) => parts.filter(Boolean).join(' ');
